export * from "./block.module";
export * from "./block.component";


// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/layout/block/index.ts